<div class="buttons-holder">
  <div class="hybrids">
    @if (!isUploaded) {
      <app-button
        iconRight="upload"
        [labelPath]="'manager.Reference.matching.hybrides.upload' | translate"
        type="filled"
        (clicked)="openDialog('Hybrides')"
      >
      </app-button>
    }
    @if (!isUploaded) {
      <app-button
        iconRight="download"
        [labelPath]="
          'manager.Reference.matching.hybrides.downloadFile' | translate
        "
        type="filled"
        (clicked)="downloadFile('Hybrides')"
        [loading]="hybridDownloadLoading"
      >
      </app-button>
    }
    @if (!isUploaded) {
      <app-button
        iconRight="download"
        [labelPath]="
          'manager.Reference.matching.hybrides.downloadTemplate' | translate
        "
        type="filled"
        (clicked)="downloadTemplate('Hybrides')"
      >
      </app-button>
    }
  </div>
  <div class="bfr-cu">
    @if (!isUploaded) {
      <app-button
        iconRight="upload"
        [labelPath]="'manager.Reference.matching.BFR_CU.upload' | translate"
        type="filled"
        (clicked)="openDialog('BFR_CU')"
      >
      </app-button>
    }
    @if (!isUploaded) {
      <app-button
        iconRight="download"
        [labelPath]="
          'manager.Reference.matching.BFR_CU.downloadFile' | translate
        "
        type="filled"
        (clicked)="downloadFile('BFR_CU')"
        [loading]="bfrCuDownloadLoading"
      >
      </app-button>
    }
    @if (!isUploaded) {
      <app-button
        iconRight="download"
        [labelPath]="
          'manager.Reference.matching.BFR_CU.downloadTemplate' | translate
        "
        type="filled"
        (clicked)="downloadTemplate('BFR_CU')"
      >
      </app-button>
    }
  </div>
  @if (isUploaded) {
    <app-file-uploader
      [datas]="uploadDatas"
      [properties]="properties[typeSelected]"
      [fileName]="fileName"
      [referenceSummary]="referenceSummary"
      uploaderType="reference"
      [columnNames]="columnNames"
      [separatorError]="separatorError"
      [separatorErrorWarnings]="separatorErrorWarnings"
      (goBack)="backOnList()"
      (doProvisioning)="doProvisioning($event)"
    >
    </app-file-uploader>
  }
</div>
